import {Box, MantineStyleProps, Transition} from '@mantine/core';
import {ReactNode} from 'react';
import {rotateLeft, rotateRight} from '../utils/Transitions';

interface FlipperProps extends MantineStyleProps {
    flipped: boolean;
    children: ReactNode[];
}

export const Flipper = ({flipped, children, ...others}: FlipperProps) => {

    if (!Array.isArray(children) || children.length != 2)
        throw new Error('Flipper must be provided precisely 2 children');

    const [front, back] = children;

    return (
        <Box {...others}>
            <Transition transition={rotateLeft} mounted={!flipped}>
                {(transitionStyles) => <Box style={transitionStyles}>{front}</Box>}
            </Transition>
            <Transition transition={rotateRight} mounted={flipped}>
                {(transitionStyles) => <Box style={transitionStyles}>{back}</Box>}
            </Transition>
        </Box>
    );
};
